import { Address } from '../../../ana-toolbox'

export type AddressComponents = google.maps.places.PlaceResult['address_components']

const getCountry = (addressComponents: AddressComponents = []): string | undefined =>
  addressComponents.find(({ types }) => types.includes('country'))?.long_name

const getCity = (addressComponents: AddressComponents = []): string | undefined =>
  addressComponents.find(({ types }) => types.includes('locality'))?.long_name

const getState = (addressComponents: AddressComponents = []): string | undefined =>
  addressComponents.find(({ types }) => types.includes('administrative_area_level_1'))?.long_name

const getZipCode = (addressComponents: AddressComponents = []): string | undefined =>
  addressComponents.find(({ types }) => types.includes('postal_code'))?.long_name

const getStreet = (addressComponents: AddressComponents = []): string | undefined =>
  addressComponents.find(({ types }) => types.includes('route'))?.long_name

const getNumber = (addressComponents: AddressComponents = []): string | undefined =>
  addressComponents.find(({ types }) => types.includes('street_number'))?.long_name

const parsePlaceDetails = ({
  address_components: addressComponents,
}: Pick<google.maps.places.PlaceResult, 'address_components'>): Address => ({
  city: getCity(addressComponents),
  country: getCountry(addressComponents),
  state: getState(addressComponents),
  zipCode: getZipCode(addressComponents),
  street: getStreet(addressComponents),
  number: getNumber(addressComponents),
})

export const googlePlacesHelpers = { parsePlaceDetails }
